import React from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit } from '../../../Shared/Brand'
import { PageHeader } from '../../../Shared/DashboardUI'

function Subscriptions() {
    return (
        <>
            <PageHeader
                title="Subscriptions"
                action={<Link className="xdb-btn" to="/user/subscriptionsdetails" style={{ textDecoration: 'none' }}>View Details</Link>}
            />
            <div style={{ maxWidth: '260px' }}>
                <div className="xdb-card" style={{ textAlign: 'center' }}>
                    <h6 style={{ color: C.ltx2, fontSize: '13px', fontWeight: 600, margin: '0 0 8px' }}>B-LOVE</h6>
                    <div style={{ fontSize: '28px', fontWeight: 700, color: C.ltx, fontFamily: fOutfit }}>$100</div>
                    <p style={{ color: C.ltx3, fontSize: '13px', margin: '6px 0 16px' }}>$200 Profit Cap</p>
                    <button className="xdb-btn" style={{ width: '100%' }} data-bs-toggle="modal" data-bs-target="#buypack">Subscribe</button>
                </div>
            </div>
        </>
    )
}

export default Subscriptions
